export default __webpack_public_path__ + "static/media/canyon.d6100108.jpg";